const keys = {
    API_KEY: "AIzaSyCnn7guePsZ0avAMA-84op2TbbL8bKILas",
    CLIENT_ID: "306463473838-c3u2orej8cd5dvmffea1e5q56songeii.apps.googleusercontent.com",
    FOOD_APP_ID : "aea63cce",
    FOOD_APP_KEY:"0ae5e5e3b445e63c347c764dddf7207e",
    ZOMATO_KEY:"0237b8caaf073e01a40bda294627a4d1"
}
 
export default keys